export enum OrderDeliveryWayEnum {
    Delivery = 1,
    Pickup = 2
}
